<i18n lang="yaml" locale="en">
  height (boxes): Height (boxes)
  width (boxes): Width (boxes)
  slide settings: Slide settings
  font: Font
  add font long: Add a font by dropping it here.
  add font short: Add as font.
</i18n>

<i18n lang="yaml" locale="de">
  height (boxes): Höhe (Kästchen)
  width (boxes): Breite (Kästchen)
  slide settings: Seiten-Einstellungen
  font: Schriftart
  add font long: Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.
  add font short: Als Schriftart hinzufügen.
</i18n>

<template>
  <div
    class="smoothSlider"
    v-hammer:pan="onPan"
    ref="slider"
  >
    <keep-alive>
      <grid
        v-if="isActive"
        class="container"
        :width="width"
        :height="height"
        :format="$project.format"
        :style="gridStyle"
        @editorMouseDown="onEditorMouseDown"
      >
        <component
          v-for="child in children"
          :key="child.getters.path"
          :path="child.getters.path"
          :is="child.getters.type"
          v-bind="child.getters.props"
        />
      </grid>
    </keep-alive>
  </div>
</template>

<script>
import Grid from '@/components/modules/Grid'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'
import fontHandler from '@/mixins/fontHandler'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'smoothSlider',
  extends: BaseModule,
  customStore: translatable,
  components: {
    Grid
  },
  mixins: [fontHandler([
    'font'
  ])],
  inject: ['$project'],
  props: {
    // eslint-disable-next-line
    _headlineSlideSettings: {
      input: 'heading',
      label: 'slide settings'
    },
    width: {
      type: Number,
      default: 192,
      min: 1,
      input: 'number',
      label: 'width (boxes)'
    },
    height: {
      type: Number,
      default: 108,
      min: 1,
      input: 'number',
      label: 'height (boxes)'
    },
    // eslint-disable-next-line
    _headlineFont: {
      input: 'heading',
      label: 'font'
    },
    font: {
      input: 'drop',
      placeholder: 'add font long',
      type: String,
      contentType: 'font',
      tooltip: 'add font short',
      default: ''
    }
  },
  data () {
    return {
      panAllowed: true
    }
  },
  computed: {
    gridHeight () {
      return 100 / (this.$project.format === 'landscape' ? 108 : 192) * this.height + 'vh'
    },
    gridWidth () {
      return 100 / (this.$project.format === 'landscape' ? 192 : 108) * this.width + 'vw'
    },
    gridStyle () {
      return {
        width: this.gridWidth,
        height: this.gridHeight,
        ...this.fontStyles.font
      }
    }
  },
  methods: {
    onEditorMouseDown (editorMouseDown) {
      this.panAllowed = !editorMouseDown
    },
    onPan (event) {
      if (this.$refs.slider && this.panAllowed) {
        this.$refs.slider.scrollLeft -= event.velocityX * 10
        this.$refs.slider.scrollTop -= event.velocityY * 10
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.smoothSlider {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
  overflow: hidden;

  * {
    box-sizing: border-box;
  }
}
</style>
